<template>
  <v-container>
    <PageTitle>О МедТочке</PageTitle>

    <p class="text-body-1 text-ui-kit-text mb-4 project-description">
      МедТочка — это бесплатная безопасная медицинская карта пациента, которую можно легко показать любому врачу.
      Возможности МедТочки не ограничиваются хранением документов. Личный кабинет охватывает весь цикл заботы о
      здоровье.
    </p>
    <p class="text-subtitle-1 text-ui-kit-text mb-4">
      МедТочкой пользуются, чтобы
    </p>
    <ul class="pl-6">
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          вовремя приходить к врачу: мы напомним вам накануне приёма
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          всегда держать под рукой результаты обследований, заключение врача и назначения — всё в одном приложении
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          безопасно открывать доступ к своей медкарте любому врачу на приёме или онлайн
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          получить рекомендации по подготовке к приёму
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          записываться на приём онлайн
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          переносить и отменять запись прямо в приложении
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          быстро находить профили любимых врачей и клиник в избранном
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          разрешать конфликтные ситуации по отзывам в чате с клиникой
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          оставлять отзывы о врачах и следить за статусом их публикации
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 mb-2 text-ui-kit-text">
          следить за своим статусом участника Клуба ПроДокторов и сроком его действия
        </p>
      </li>
      <li class="list-item">
        <p class="text-body-1 text-ui-kit-text mb-2">
          получать и хранить все скидочные купоны Клуба ПроДокторов
        </p>
      </li>
    </ul>
  </v-container>
</template>

<style lang="scss" scoped>
.project-description {
  max-width: 800px;
}

.list-item {
  color: $t-primary;
  font-size: 18px;
}
</style>
